import React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';

import { CirclePerson2, Toast } from '../../../../brenger-shared-ui';
import { useTypedSelector } from '../../../../hooks';
import { useNotification } from '../../../../hooks/useNotification';
import { getPriceStructure } from '../../ducks';

export const ExtraCareGlassNotification: React.FC = () => {
  const notification = useNotification('extra-care--glass-insurance');
  const progressStep = useTypedSelector(state => state.generalTransport.layout.step);
  const structure = useTypedSelector(getPriceStructure);
  const hasExtraCareGlass = structure?.global?.some(globalItem => {
    return globalItem.charge === 'product_selection.fragile';
  });

  React.useEffect(() => {
    if (progressStep === 3 && hasExtraCareGlass) {
      notification.add();
    } else {
      notification.remove();
    }
  }, [progressStep, hasExtraCareGlass]);

  return (
    <Toast
      isVisible={notification.isVisible}
      prefix={<CirclePerson2 />}
      handleClose={notification.removeForOneSession}
      title={<Translate id="request_flow.extra_care.glass_insurance.notification.title" />}
      body={<Translate id="request_flow.extra_care.glass_insurance.notification.text" />}
    />
  );
};
